var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal rounded"},[_c('vue-plyr',{ref:"plyr"},[_c('video',{attrs:{"poster":"poster.png","src":_vm.content.src}},[_c('source',{attrs:{"src":_vm.content.src,"type":"video/mp4","size":"720"}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }